const data = {
  'title': 'Cherry - Bitcoin Block Explorer',
  'content': 'Cherry is a block explorer built with serverless AWS services like Lambda, API Gateway and S3. It allows users to search for real-time and historical information about the Bitcoin blockchain, including data related to blocks, transactions and addresses.',
  'github': 'https://github.com/tigeryant/cherry-fe-v1',
  // 'live': 'http://cherry-frontend.s3-website.eu-west-2.amazonaws.com/',
  'technologies': [
    'AWS',
    'Bitcoin',
    'React',
    'Tailwind',
    'Raspberry Pi',
    'SSH'
  ],
}

export default data